import { render, staticRenderFns } from "./PracticePerformance.vue?vue&type=template&id=7621f6f2&"
import script from "./PracticePerformance.vue?vue&type=script&lang=js&"
export * from "./PracticePerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports